












































import { EventType } from '@/store/modules/events'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ViewPageViewsModal from './ViewPageViews.modal.vue'

@Component({
  components: {
    ViewPageViewsModal
  }
})
export default class OverviewChart extends Vue {
  @Prop() dateTo?: Date;
  @Prop() dateFrom?: Date;
  @Prop() marketKey?: string;
  @Prop() eventType?: EventType;
  @Prop() markets?: any;

  totalDurationValue: number = 0;
  firstItem: any = {};

  views: any = [];
  pageViews: any = [];
  isHidden: boolean = true;
  viewtime: number = 0;

  mounted () {
    this.getComponentData()
  }

  @Watch('views')
  setHiddenContainer (value: boolean) {
    this.isHidden = this.views.length === 0
  }

  get currentMarket () {
    const market = this.markets.find((market: any) => market.value === this.marketKey)
    return market.text
  }

  @Watch('dateTo')
  @Watch('dateFrom')
  @Watch('marketKey')
  async getComponentData () {
    await this.$store
      .dispatch('getPageViews', {
        dateTo: this.dateTo,
        dateFrom: this.dateFrom,
        eventType: this.eventType,
        marketKey: this.marketKey
      })
      .then((res: any) => {
        this.views = res.filter(
          (item: any) => item.eventtype === (this.eventType === 1 ? 4 : 5)
        )
        this.pageViews = res.filter(
          (item: any) => item.eventtype === (this.eventType === 1 ? 10 : 11)
        )
        this.mapData()
        this.$emit('increment')
      })
  }

  setDurationValues (point: any) {
    this.viewtime = Math.ceil(point.totalViewTime / 60000);
    (this.$refs[`chart-${this.eventType}`] as any)?.chart.update({
      series: [
        {
          data: [
            Math.round(
              this.calcPercentage(
                point.totalViewTime,
                this.totalDurationValue
              ) * 10
            ) / 10
          ]
        }
      ],
      yAxis: {
        stops: [
          [0.9, point.color] // product colour
        ]
      }
    })
  }

  paneChartOptions: any = {
    chart: {
      type: 'solidgauge',
      height: '75%' // Adjust as needed
    },
    title: {
      text: ''
    },
    pane: {
      center: ['50%', '85%'],
      size: '140%',
      startAngle: -90,
      endAngle: 90,
      background: {
        backgroundColor: '#EEE',
        innerRadius: '60%',
        outerRadius: '100%',
        shape: 'arc'
      }
    },
    tooltip: {
      enabled: false
    },
    yAxis: {
      stops: [
        [0.9, '#55BF3B'] // product colour
      ],
      lineWidth: 0,
      minorTickInterval: null,
      tickPixelInterval: 400,
      tickWidth: 0,
      labels: {
        y: 16
      },
      min: 0,
      max: 100,
      title: {
        text: ''
      }
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: 5,
          borderWidth: 0,
          useHTML: true
        }
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: 'Speed',
        data: [0],
        dataLabels: {
          format:
            '<div style="text-align:center">' +
            '<span style="font-size:25px">{y}%</span><br/>' +
            '<span style="font-size:12px;opacity:0.4">Of Total View Time</span>' +
            '</div>'
        },
        tooltip: {
          valueSuffix: 'Minutes viewed'
        }
      }
    ]
  };

  chartOptions: any = {
    chart: {
      type: 'bar'
    },
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },
    tooltip: {
      formatter: function (): string {
        return `<b>${(this as any).point.name}</b><br>Viewed ${(this as any).point.y} times, for ${Math.ceil(
          (this as any).point.totalViewTime / 60000
        )} minutes`
      }
    },
    xAxis: {},
    yAxis: {
      title: {
        text: 'View Count'
      },
      allowDecimals: false
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        cursor: 'pointer',
        point: {
          events: {
            click: (event: any) => {
              this.setDurationValues(event.point)
            }
          }
        }
      }
    },
    series: [
      {
        data: []
      }
    ]
  };

  mapData () {
    const data = this.views.map((item: any) => {
      return {
        name: item.title,
        productName: item.productname,
        y: parseInt(item.count),
        color: item.color,
        totalViewTime: this.calculateTotalViewTime(item.trackingkey),
        trackingKey: item.trackingkey
      }
    });

    (this.$refs[`view-chart-${this.eventType}`] as any)?.chart.update(
      {
        xAxis: {
          categories: data.sort((a: any, b: any) => b.y - a.y).filter((item: { totalViewTime: number; }) => item.totalViewTime > 0).map(
            (view: any) => `${view.productName}: ${view.name}`
          )
        },
        series: [{ data: data.sort((a: any, b: any) => b.y - a.y).filter((item: { totalViewTime: number; }) => item.totalViewTime > 0) }]
      },
      true,
      true
    )

    this.firstItem = (this.$refs[
      `view-chart-${this.eventType}`
    ] as any)?.chart.series[0].data[0]

    this.totalDurationValue = (this.$refs[
      `view-chart-${this.eventType}`
    ] as any)?.chart.series[0].data.reduce(
      (acc: number, item: any) => acc + item.totalViewTime,
      0
    )
    this.viewtime = ((this.firstItem !== undefined) ? (Math.ceil(this.firstItem.totalViewTime / 60000)) : 0);

    (this.$refs[`chart-${this.eventType}`] as any)?.chart.update({
      series: [
        {
          data: [
            Math.round(
              this.calcPercentage(
                this.firstItem !== undefined ? this.firstItem.totalViewTime : 0,
                this.totalDurationValue
              ) * 10
            ) / 10
          ]
        }
      ],
      yAxis: {
        stops: [
          [0.9, this.firstItem !== undefined ? this.firstItem.color : ''] // product colour
        ]
      }
    })
  }

  calcPercentage (x: number, y: number) {
    return (x / y) * 100
  }

  calculateTotalViewTime (trackingKey: string) {
    let totalViewTime = 0
    this.pageViews.forEach((item: any) => {
      if (item.trackingkey === trackingKey) {
        if (isNaN(parseInt(item.totaltime))) {
          totalViewTime += 0
        } else {
          totalViewTime += parseInt(item.totaltime)
        }
      }
    })

    return totalViewTime
  }
}
